import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    router: '',
    user: null,
    token: '',
    detail: null
  },
  mutations: {
    router (state, info) {
      state.router = info || ''
    },
    token (state, info) {
      state.token = info || ''
      localStorage.token = info || ''
    },
    user (state, info) {
      state.user = info || null
      localStorage.user = JSON.stringify(info) || null
    },
    userInfo (state, info) {
      state.userInfo = info || {}
      localStorage.userInfo = JSON.stringify(info) || null
    },
    detail (state, info) {
      state.detail = info || null
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js